import { render, staticRenderFns } from "./CKeditorComponent.vue?vue&type=template&id=1c5d8635&scoped=true"
import script from "./CKeditorComponent.vue?vue&type=script&lang=js"
export * from "./CKeditorComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5d8635",
  null
  
)

export default component.exports